<template>
  <div class="cut-overlay">
    <p class="instructions">Drag the edges to lengthen or shorten your Hilite.</p>
    <div class="cut-bar" v-on:mouseleave="detectMouseleave">
      <div v-for="clip in clipsForCut" v-on:mouseover="detectMouseover" :class="[clip.selected ? 'selected' : '' ]" class="cut-clip">
        <div v-if="clip.firstSelected" class="handle-left handle" :class="[currentHandle == 'left' ? 'active' : '' ]" v-on:mousedown="detectMousedown($event, 'left')"></div>
        <div v-if="clip.lastSelected" class="handle-right handle" :class="[currentHandle == 'right' ? 'active' : '' ]" v-on:mousedown="detectMousedown($event, 'right')"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "Cut",
  props: ["clipsForCut"],
  data: function() {
    return {
      dragging: false,
      currentHandle: null
    }
  },
  mounted() {
    this.detectFirstLast();
  },
  methods: {
    detectMouseleave: function() {
      //cancel dragging if you leave the trim zone
      this.dragging = false;
      this.currentHandle = null;
    },
    detectMousedown: function(e, handle) {
      let that = this;
      this.dragging = true;
      this.currentHandle = handle;
      this.pageX = e.pageX;

      document.addEventListener("mouseup", function stopDragging() {
        that.dragging = false;
        that.currentHandle = null;
        that.$store.commit("setEditorClips", that.clipsForCut.filter(clip => clip.selected == true));
        document.removeEventListener("mouseup", stopDragging);
      });
    },
    detectFirstLast() {
      this.clipsForCut.forEach((element, index, array) => {
        Vue.set(element, "firstSelected", false)
        Vue.set(element, "lastSelected", false)

        if (array[index - 1] && array[index-1].selected == false && element.selected == true) {
          element.firstSelected = true;
        }
        if (array[index + 1] && array[index+1].selected == false && element.selected == true) {
          element.lastSelected = true;
        }
        if (element.selected && !array[index+1]) {
          element.lastSelected = true;
        }
        if (element.selected && !array[index-1]) {
          element.firstSelected = true;
        }
      });
    },
    detectMouseover: function(e) {
      if (this.dragging == false || (" " + e.target.className + " ").replace(/[\n\t]/g, " ").indexOf(" handle ") > -1 ) {
        return false;
      }

      let direction = false;

      if (this.pageX && this.pageX < e.pageX) {
        direction = "right";
      } else if (this.pageX && this.pageX > e.pageX) {
        direction = "left";
      }

      this.pageX = e.pageX;

      let clipElems = Array.prototype.slice.call( document.getElementsByClassName('cut-bar')[0].children );
      let selectedClipElems = Array.prototype.slice.call( document.getElementsByClassName('cut-clip selected') );

      let lastClipIndex = clipElems.indexOf(selectedClipElems[selectedClipElems.length - 1]);
      let firstClipIndex = clipElems.indexOf(selectedClipElems[0]);
      let currentClipIndex = clipElems.indexOf(e.target);

      function isOnly(clip) {
        if (clip.firstSelected && clip.lastSelected) {
          return true;
        } else {
          return false;
        }
      }

      if (this.currentHandle == "left" && direction == "left") {
        this.clipsForCut[currentClipIndex].selected = true;
      }

      if (this.currentHandle == "left" && direction == "right") {
        if (isOnly(this.clipsForCut[currentClipIndex]) == false ) {
          this.clipsForCut[currentClipIndex].selected = true;
          if (this.clipsForCut[currentClipIndex - 1]) {
            this.clipsForCut[currentClipIndex - 1].selected = false;
          }
        }
      }

      if (this.currentHandle == "right" && direction == "right") {
        this.clipsForCut[currentClipIndex].selected = true;
      }

      if (this.currentHandle == "right" && direction == "left") {
        if (isOnly(this.clipsForCut[currentClipIndex]) == false) {
          this.clipsForCut[currentClipIndex].selected = true;
          if (this.clipsForCut[currentClipIndex + 1]) {
            this.clipsForCut[currentClipIndex + 1].selected = false;
          }
        }
      }

      this.detectFirstLast();
    }
  }
};
</script>

<style lang="stylus" scoped>
.cut-overlay
  padding: 0px 30px
  height: 100%
  display: flex
  align-items: center
  .cut-bar
    width: 100%
    height: 40px
    background: rgba(255,255,255,.20)
    display: flex
    justify-content: space-around
    .cut-clip
      width: 100%
      margin-right: 1px
      &:last-of-type {
        margin-right: 0px;
      }
      .handle-left, .handle-right
        content: ""
        width: 6px
        height: 120%
        position: absolute
        top: -10%
        background: #d85633
        cursor: ew-resize
        user-select: none
        touch-action: none
        &:active, &.active
          transform: scale(1.25)
      .handle-left
        left: -1px
      .handle-right
        right: -1px
      &.selected
        background: rgba(255,255,255,.75)
        position: relative
</style>
